import Button from '@ui/buttons/Button'
import { ModalBottom } from '@ui/components/Modal'
import {
  Picker,
  PickerItemProps,
  PickerProps,
} from '@react-native-picker/picker'
import Typography from '@ui/typography'
import { useState } from 'react'
import { Text, View } from 'react-native'
import { twMerge } from 'tailwind-merge'

const schema = {
  min: -16,
  max: 16,
  step: 0.25,
}

export default function PickerTest() {
  const [open, setOpen] = useState(false)
  const [value1, setValue1] = useState<string>('')
  const [value2, setValue2] = useState<string>('')

  const valuesBeforeDot = Array.from(
    { length: schema.max - schema.min + 1 },
    (_, i) => {
      const value = schema.min + i
      return { label: value.toString(), value: value.toString() }
    }
  ).reverse()

  const valuesAfterDot = Array.from({ length: 1 / schema.step }, (_, i) => {
    const value = i * schema.step
    return {
      label: value.toFixed(2).split('.')[1],
      value: value.toFixed(2).split('.')[1],
    }
  }).reverse()

  const itemStyle = {
    fontSize: 32,
    fontWeight: 'normal',
    // height: 200,
  } satisfies PickerProps['itemStyle']

  return (
    <>
      <Button onPress={() => setOpen(true)}>Open Picker</Button>
      <ModalBottom
        open={open}
        center
        disableScroll
        hideBottomSpace
        intensity={0}
      >
        <View
          className={twMerge(
            'flex w-full flex-col items-center rounded-2xl',
            'border border-black/10',
            'gap-4 px-16 pb-0 pt-12'
          )}
        >
          <Typography
            variant="XLB"
            className="text-center uppercase tracking-normal"
          >
            Axis
          </Typography>
          <View className="flex w-full flex-row items-center">
            <View className="h-full w-1/2">
              <Picker
                selectedValue={value1}
                onValueChange={(itemValue) => setValue1(itemValue)}
                itemStyle={{ ...itemStyle, textAlign: 'right' }}
                // style={{ borderColor: 'black', borderWidth: 1 }}
              >
                {valuesBeforeDot.map((option) => (
                  <Picker.Item
                    key={option.value}
                    label={option.label}
                    value={option.value}
                  />
                ))}
              </Picker>
            </View>
            <Typography variant="XLB" className="flex items-center">
              .
            </Typography>
            <View className="h-full w-1/2">
              <Picker
                selectedValue={value2}
                onValueChange={(itemValue) => setValue2(itemValue)}
                itemStyle={{ ...itemStyle, textAlign: 'left' }}
              >
                {valuesAfterDot.map((option) => (
                  <Picker.Item
                    key={option.value}
                    label={option.label}
                    value={option.value}
                  />
                ))}
              </Picker>
            </View>
          </View>
        </View>
      </ModalBottom>
    </>
  )
}
